import { classifyRI, RiStatus } from '@leopart/calc';
import { getHooperScaleColor } from '../constants/readiness';

/**
 * Color-helper condivisi tra `TeamReadinessTab` (summary bar) e le righe/card
 * atleta (`ReadinessMatrixRow`, `ReadinessCard`): un'unica fonte, nessuna
 * duplicazione. Le soglie di dominio del Recovery Index restano in
 * `@leopart/calc` (`classifyRI`) — qui solo la mappa fascia→colore.
 */

// Soglie centralizzate in @leopart/calc (classifyRI). Prima 90/75/60 non canoniche.
// Colori letti dai token tema `--ri-*` (_themes.scss) invece di ri-hardcodare gli
// hex: fonte unica condivisa con la heatmap Sforzo+Recovery ed EffortRecoveryRow.
const RI_DOMAIN_COLOR: Record<RiStatus, string> = {
  good: 'var(--ri-good)',
  normal: 'var(--ri-normal)',
  warning: 'var(--ri-warning)',
  critical: 'var(--ri-critical)',
};

/** Colore del valore RI (Recovery Index) in base alla fascia @leopart/calc. */
export function getDomainColor(score: number): string {
  return RI_DOMAIN_COLOR[classifyRI(score)];
}

/**
 * Sonno, stress, umore e DOMS stanno tutti sulla stessa scala 1-5, quindi
 * usano la stessa rampa di colore: vedi `getHooperScaleColor`.
 */
export const getMentalValueColor = getHooperScaleColor;
export const getDOMSValueColor = getHooperScaleColor;

/** Colore ACWR: verde 0.8-1.3, ambra nelle code, rosso oltre. */
export function getACWRValueColor(value: number): string {
  if (value >= 0.8 && value <= 1.3) return '#27ae60';
  if ((value >= 0.5 && value < 0.8) || (value > 1.3 && value <= 1.5)) return '#FFD15A';
  return '#f57c73';
}

/** Colore sRPE settimanale: verde ≤300, ambra ≤500, rosso oltre. */
export function getSRPEValueColor(value: number): string {
  if (value <= 300) return '#27ae60';
  if (value <= 500) return '#FFD15A';
  return '#f57c73';
}
